import script from "./CartBcIntro.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartBcIntro.vue?vue&type=script&lang=ts&setup=true"

import "./CartBcIntro.vue?vue&type=style&index=0&id=a4127292&lang=scss&scoped=true"
import "./CartBcIntro.vue?vue&type=style&index=1&id=a4127292&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4127292"]])

export default __exports__